/**
 * Uzbek strings of the `Bitimlar` board's card, its refusal modal and the deal's destination
 * picker (§3.2, §3.3, AC-2-01). Spread into `uz`, so a key here is a `TranslationKey` like any
 * other.
 */
export const uzDealsBoard = {
  "dealsBoard.noPhone": "raqamsiz",
  "dealsBoard.lastMessage": "Oxirgi xabar: {time}",
  "dealsBoard.aiMark": "Suhbat AI rejimida",
  "dealsBoard.sla.left": "SLA {time}",
  "dealsBoard.sla.overdue": "Kechikkan {time}",

  "dealsBoard.refused.conditions": "{stage} bosqichiga o'tish shartlari",
  "dealsBoard.refused.met": "bajarilgan",
  "dealsBoard.refused.unmet": "bajarilmagan",
  "dealsBoard.refused.checklistError": "Shartlar ro'yxatini yuklab bo'lmadi.",
  "dealsBoard.refused.close": "Yopish",
  "dealsBoard.refused.open": "Bitimni ochish",

  "dealsBoard.destination.label": "Manzil",
  "dealsBoard.destination.several": "«{words}» bir nechta yo'nalishga mos keladi. Bittasini tanlang:",
  "dealsBoard.destination.one": "«{words}» katalogda topildi. Biriktirish:",
  "dealsBoard.destination.advice": "maslahat kerak",
  "dealsBoard.destination.adviceHint": "«{words}» katalogda topilmadi. Mijozdan qaysi joyni nazarda tutganini so'rang.",
  "dealsBoard.destination.saveFailed": "Manzilni saqlab bo'lmadi",
  "dealsBoard.destination.catalogError": "Katalogni yuklab bo'lmadi.",
  "dealsBoard.destination.retry": "Qayta urinish",
} as const;
